import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import { ErrorText } from "../../../components";

export default class PincodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.initState();

    // Binding methods
    this.onDistrictChange = this.onDistrictChange.bind(this);
    this.onPincodeChange = this.onPincodeChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  initState = () => ({
    form: {
      district: null,
      pincode: null,
    },
    errors: {},
    districtList: this.getDistrictsList(),
  });

  getDistrictsList = () => [
    { id: 1, label: "Thiruvananthapuram", value: "Thiruvananthapuram" },
    { id: 2, label: "Kollam", value: "Kollam" },
    { id: 3, label: "Pathanamthitta", value: "Pathanamthitta" },
    { id: 4, label: "Alappuzha", value: "Alappuzha" },
    { id: 5, label: "Kottayam", value: "Kottayam" },
    { id: 6, label: "Idukki", value: "Idukki" },
    { id: 7, label: "Ernakulam", value: "Ernakulam" },
    { id: 8, label: "Thrissur", value: "Thrissur" },
    { id: 9, label: "Palakkad", value: "Palakkad" },
    { id: 10, label: "Malappuram", value: "Malappuram" },
    { id: 11, label: "Kozhikode", value: "Kozhikode" },
    { id: 12, label: "Wayanad", value: "Wayanad" },
    { id: 13, label: "Kannur", value: "Kannur" },
    { id: 14, label: "Kasaragod", value: "Kasaragod" },
  ];

  getPincodeOptions = () => {
    const { pincodeList } = this.props;
    return pincodeList.map((pincode) => ({
      value: pincode.code,
      label: `${pincode.name} (${pincode.code})`,
      id: pincode.id,
    }));
  };

  onSave() {
    if (!this.validateForm()) return;
    const { form } = this.state;
    this.props.addPinCode({
      pincode: form.pincode?.id || "",
    });
    this.setState(this.initState());
  }

  validateForm() {
    const { form } = this.state;
    const errors = {};

    if (!form.district) errors.district = "Required";
    if (!form.pincode) errors.pincode = "Required";

    this.setState({ errors });
    return isEmpty(errors);
  }

  onDistrictChange(selectedOption) {
    const { fetchPincodes } = this.props;
    fetchPincodes(selectedOption.id);
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        district: selectedOption,
        pincode: null,
      },
      errors: {
        ...prevState.errors,
        district: "",
        pincode: "",
      },
    }));
  }

  onPincodeChange(selectedOption) {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        pincode: selectedOption,
      },
      errors: {
        ...prevState.errors,
        pincode: "",
      },
    }));
  }

  onClose() {
    this.setState(this.initState());
    this.props.onHide();
  }

  render() {
    const { form, errors, districtList } = this.state;
    const { show } = this.props;

    const pincodeOptions = this.getPincodeOptions();

    return (
      <Modal show={show} onHide={this.onClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Pincode</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label
                  className={classNames({ "text-danger": errors.district })}
                >
                  District
                </label>
                <Select
                  name="district"
                  value={form.district}
                  onChange={this.onDistrictChange}
                  options={districtList}
                  placeholder="Select district"
                  className={classNames({ "is-invalid": errors.district })}
                />
                <ErrorText error={errors.district} />
              </div>
            </div>
            <div className="col-md-6 mb-2">
              <div className="form-group">
                <label
                  className={classNames({ "text-danger": errors.pincode })}
                >
                  Pincode
                </label>
                <Select
                  name="pincode"
                  value={form.pincode}
                  onChange={this.onPincodeChange}
                  options={pincodeOptions} // Pincode options converted from props
                  placeholder="Select pincode"
                  isDisabled={pincodeOptions.length === 0}
                  className={classNames({ "is-invalid": errors.pincode })}
                />
                <ErrorText error={errors.pincode} />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={this.onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={this.onSave}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
